import { CampaignsControllerGetUsersCampaignsListCommunityTypeEnum } from '@bvengineering/cas-member-gateway-service-client';
import { useApiQuery } from '@/api/hooks/useQuery';
import { campaignKeys } from '@/api/queryKeys';

/**
 * Hook to fetch creator campaigns using Member Gateway SDK.
 * Defaults to communityType=Creator — results only include creator-community campaigns.
 * Returns CampaignListResponse with results array of ListCampaignResponseItem.
 */
export function useCampaigns(
  offset?: number,
  limit?: number,
  communityType = CampaignsControllerGetUsersCampaignsListCommunityTypeEnum.Creator
) {
  return useApiQuery({
    queryKey: [...campaignKeys.lists(), { offset, limit, communityType }] as const,
    queryFn: (api) => async () => {
      const response = await api.campaigns.campaignsControllerGetUsersCampaignsList(
        offset,
        limit,
        communityType
      );
      return response.data;
    },
  });
}
